import axios, { isAxiosError } from "axios";
import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { GetNotificationsResponse } from "@src/types/support";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { mockNotifications } from "./mocks/get-alarms-notifications-mock";

const USE_MOCK = false;

export const getAlarmsAndNotifications = async (
  namespace: string,
): Promise<GetNotificationsResponse> => {
  if (USE_MOCK) {
    return mockNotifications;
  }

  // TODO: Update supportUrlEnvVar with the real URL once it is available.
  const url = supportUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<GetNotificationsResponse>(
      `${url}/api/v1/ns/${namespace}/notifications`,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch notifications. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while fetching notifications.",
    );
  }
};
